import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination
} from '@mui/material';

import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../components/_dashboard/user';
//
import USERLIST from '../_mocks_/user';
import Request from '../components/common/Request';
import {  Paths, GetAzurePath, AzurePaths } from '../components/common/Constants';

import '../App.css';

import { useNavigate , Link } from "react-router-dom";
import { useRouter } from "../components/common/use-router.js";
import { CSVLink, CSVDownload } from "react-csv";
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'Email', label: 'Email', alignRight: false },
  // { id: 'company', label: 'Company', alignRight: false },
  // { id: 'role', label: 'Role', alignRight: false },
  //  { id: 'isVerified', label: 'Verified', alignRight: false },
  { id: 'CreatedAt', label: 'CreatedAt', alignRight: false },
   { id: 'status', label: 'Status', alignRight: false },
  { id: '' }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {

  //console.log(orderBy);
  if (orderBy === "CreatedAt")
  {
    if ( new Date(b[orderBy]) < new Date(a[orderBy] ) ){
      return -1;
    }
    if ( new Date(b[orderBy]) > new Date(a[orderBy] ) ){
      return 1;
    }

    return 0;
  }

  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, filterChecked) {
  if (query) {
    array = filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }

  if (filterChecked.indexOf(0) > -1){
    array  = filter(array, (_user) => _user.Newsletter === true);
  }

  
  if (filterChecked.indexOf(1) > -1){
    array  = filter(array, (_user) => _user.IsVisibleToOthers === true);
  }

  
  if (filterChecked.indexOf(2) > -1){
    array  = filter(array, (_user) => _user.RidesVisibleToPublic === true);
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  // if (query) {
  //   return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  // }
  return stabilizedThis.map((el) => el[0]);
}

export default function Users() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [actionUserId, setActionUserId] = useState(null);
  const [action, setAction] = useState(null);
  const [orderBy, setOrderBy] = useState('Username');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterChecked, filterSetChecked] = useState([0]);
  const [userList, setUserList] = useState(null);
  const navigate = useNavigate ();
  const router = useRouter(); 

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };



  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = userList.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0);
  };


  useEffect(async () =>{
    
    var result = await Request.Get(Paths.Users);
    var data = result.data.Users;
    data.forEach(element => {
      element.id = element.UserId;
      element.name = element.Username;
      element.status = "active";
      element.avatarUrl = GetAzurePath( AzurePaths.UserImageThumb + element.UserId);
    });
    //userList = result.data;
    //console.log(result.data.Users);
    console.log(data);
    console.log(USERLIST);
    setUserList(data);
  //  setUserList(USERLIST);
   
  }, []);

  useEffect(() => {

    if (action != null){
      console.log(actionUserId, action);
      if (action === 'delete') {
          setConfirmDialogOpen(true);
      }
      else if (action === 'edit') {
          console.log("navigate");
          
        router.push("/dashboard/user/" + actionUserId );
      }
      setAction(null);
    }
   
  }, [action]);

/* DIALOG */
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);

  const handleConfirmFailed = async () => {
    setConfirmDialogOpen(false);
    setActionUserId(null);
  };

  const handleConfirmSuccess = async () => {
    setConfirmDialogOpen(false);

    var result = await Request.Delete(Paths.DeleteUser.replace("{id}", actionUserId));
    if (result.ok){
      alert("done");

      var filtered = userList.filter(function(value, index, arr){ 
        return value.id != actionUserId;
      });
      setUserList(filtered);
      setSelected([]);
    }
    setActionUserId(null);
  };


  if (userList == null){
    return <Page title="User"><Container></Container></Page>
  }
/* DIALOG */


  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - userList.length) : 0;

  const filteredUsers = applySortFilter(userList, getComparator(order, orderBy), filterName, filterChecked);

  const isUserNotFound = filteredUsers.length === 0;

    const moreMenuSelection = (id, action) => {
    setActionUserId(id);
    setAction(action);

    };




  return (
    <Page title="User">


      <Dialog
        open={confirmDialogOpen}
        keepMounted
        onClose={handleConfirmFailed}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Use Google's location service?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Let Google help apps determine location. This means sending anonymous
            location data to Google, even when no apps are running.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmFailed}>Disagree</Button>
          <Button onClick={handleConfirmSuccess}>Agree</Button>
        </DialogActions>
      </Dialog>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            User
          </Typography>
          <Button
            variant="contained"
            component={RouterLink}
            to="#"
            startIcon={<Icon icon={plusFill} />}
          >
            New User
          </Button>
          <CSVLink  filename={"export.csv"} data={filteredUsers} headers={[ {label:"Email", key:"Email"}, {label:"Username", key:"name"}]} >
            Download me
          </CSVLink>
        </Stack>

        <Card>
          <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            filterChecked={filterChecked} 
            filterSetChecked={filterSetChecked}
            showFilter={true}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={userList.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const { id, name, Email, role, status, company, avatarUrl, isVerified, CreatedAt } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, name)}
                            />
                          </TableCell>
                          <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Avatar alt={name} src={avatarUrl} />
                              <Typography variant="subtitle2" noWrap>
                                <Link to={"/dashboard/user/" + id}> {name}</Link>
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">{Email}</TableCell>
                          {/* <TableCell align="left">{company}</TableCell>
                          <TableCell align="left">{role}</TableCell>
                          <TableCell align="left">{isVerified ? 'Yes' : 'No'}</TableCell> */}
                          <TableCell align="left">{CreatedAt}</TableCell>
                          <TableCell align="left">
                            <Label
                              variant="ghost"
                              color={(status === 'banned' && 'error') || 'success'}
                            >
                              {sentenceCase(status)}
                            </Label>
                          </TableCell>
                  
                          <TableCell align="right">
                            <UserMoreMenu canEdit={true} id={id} selected={moreMenuSelection} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
